export default __webpack_public_path__ + "static/media/Farmote-Product-Logo-(white).ab4d1bb4.png";